<div class="position-relative">
	<div>
		<div class="glaeSegmentHeader" cvLocalizedText langSection="Games_Reward_Estimator" langKey="Reward_Estimator">Reward Estimator</div>
		<p class="glaeSegmentText" cvLocalizedText langSection="Games_Reward_Estimator" langKey="Reward_Estimator_Description">This will provide the creator a insight of how much can they spend and also manage their budget.</p>
		<div class="my-3">
			<button type="button" class="btn btn-secondary" cvLocalizedText langSection="Games_Reward_Estimator" langKey="Estimate" (click)="openMetricModal()">Estimate</button>
		</div>
	</div>
</div>